import React from 'react';

import { SearchPagination } from '@uncinc/react-searchkit';

import './style.scss';

const SearchAllContentPagination = () => (
  <div className="SearchAllContent__Pagination">
    <SearchPagination
      previousLabel={<div className="Pagination__previous"><i className="icon-before icon-arrow" /></div>}
      nextLabel={<div className="Pagination__next"><i className="icon-after icon-arrow" /></div>}
    />
  </div>
);

export default SearchAllContentPagination;
